import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    personal: [],
    /* Info de paginación */
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,

    nombre: '',
    incluirInactivos: false,
    nombreBusqueda: '',

    list: [],
    selectList: [],

    // personalStatus: [],
    // fechaDesdeStatus: moment(new Date((new Date().getFullYear()), 
    //     (new Date().getMonth()), 1)).format('YYYY-MM-DD'),
    // fechaHastaStatus: moment(new Date()).format('YYYY-MM-DD'),

    personalActivo: [],
    fechaActivo: moment(new Date()).format('YYYY-MM-DD'),
};

const mutations = {
    updateField,
    
    'INICIALIZAR_OPCIONES'(state) {
        state.personal = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
        state.nombreBusqueda = '';
    },

    'INICIALIZAR_PERSONAL' (state) {
        state.personal = [];
    },
    'SET_PERSONAL' (state, personal) {
        state.personal = personal;
        state.totalRegistros = personal.length;
    },
    'SET_FILTERED_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalRegistros = params.totalRegistros;
    },
    'SET_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalPaginas = params.totalPaginas;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
    },

    'INICIALIZAR_PERSONAL_LIST' (state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_PERSONAL_LIST' (state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },

    // 'SET_PERSONAL_STATUS' (state, status) {
    //     state.personalStatus = status;
    // },
    'SET_PERSONAL_ACTIVO' (state, personal) {
        state.personalActivo = personal;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getPersonal: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR_PERSONAL');
            
            let queryString = '';
            
            if (state.nombre) {
                if (queryString == '') {
                    queryString = '?nombre=' + state.nombre;
                } else {
                    queryString += '&nombre=' + state.nombre;
                }
            }
            
            if ((/true/i).test(state.incluirInactivos)) {
                if (queryString == '') {
                    queryString += '?incluirInactivos=true';
                } else {
                    queryString += '&incluirInactivos=true';
                }
            }

            apiAxios.get('personal' + queryString)
                .then(res => {
                    let params = {
                        paginaActual: 1,
                        totalRegistros: res.data.length
                    }
                    commit ('SET_FILTERED_PAGINATION', params);

                    let personal = res.data;
                    personal.sort(function(a, b){
                        let x = a.nombreCompleto.toLowerCase();
                        let y = b.nombreCompleto.toLowerCase();
                        if (x < y) { 
                            return -1; 
                        }
                        if (x > y) {
                            return 1;
                        }
                        return 0;
                    });

                    commit ('SET_PERSONAL', personal);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getList: ({ commit }, personalActivo) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PERSONAL_LIST');

            let queryString = '';
            
            if (!(/true/i).test(personalActivo)) {
                queryString = '?incluirInactivos=true';
            }

            apiAxios.get('personal/list' + queryString)
                .then(res => {
                    let selectList = res.data.map( personal => personal.nombre.trim() );

                    let params = {
                        list: res.data,
                        selectList
                    }
                    commit('SET_PERSONAL_LIST', params);

                    resolve()
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    personalActivo (state) {
        return state.personalActivo;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}